import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tabs: [], // { title, pageCode } 형태 추천
  activeTab: null,
};

const tabSlice = createSlice({
  name: 'tabs',
  initialState,
  reducers: {
    addTab: (state, action) => {
      const exists = state.tabs.find(tab => tab.pageCode === action.payload.pageCode);
      if (!exists) {
        state.tabs.push(action.payload);
      }
      state.activeTab = action.payload.pageCode;
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    removeTab: (state, action) => {
      state.tabs = state.tabs.filter(tab => tab.pageCode !== action.payload);
      if (state.activeTab === action.payload) {
        state.activeTab = state.tabs.length > 0 ? state.tabs[state.tabs.length - 1].pageCode : null;
      }
    },
    clearTabs: (state) => {
      state.tabs = [];
      state.activeTab = null;
    },
  },
});

export const { addTab, setActiveTab, removeTab, clearTabs } = tabSlice.actions;
export default tabSlice.reducer;
